import store from 'Src/store';
import { deepMerge } from 'Utils/functions';
import {
  DATASOURCE,
  DOMAIN,
  EVENT,
  FEATURE,
} from 'Services/Logger/models';

const datasources = Object.values(DATASOURCE);
const domains = Object.values(DOMAIN);
const events = Object.values(EVENT);
const features = Object.values(FEATURE);

export const isDataSource = token => datasources.includes(token);
export const isDomain = token => domains.includes(token);
export const isEvent = token => events.includes(token);
export const isFeature = token => features.includes(token);

export function extractDataSource(stringtokens = '') {
  const domain = {};
  const feature = {};
  const trail = [];
  let datasource;

  stringtokens
    .split('.')
    .forEach((token) => {
      if (isDataSource(token)) datasource = token;
      else if (isDomain(token)) domain.name = token;
      else if (isFeature(token)) feature.name = token;
      else if (isEvent(token)) feature.event = token;
      else trail.push(token);
    });

  if (trail.length) feature.trail = trail.join('.');

  return Object.assign({ datasource, domain, feature });
}

export function createContext(id, domain) {
  const { application } = store.getState() ?? {};
  const context = {
    ...application,
  };

  if (id) context.trackingId = id;
  if (domain) context.domain = { name: domain };

  return context;
}

export function formatPayload(fullData = {}) {
  const { datasource, applicationProcessId, ...data } = fullData;
  const result = {};
  if (Object.keys(data).length) result.view = { data };
  if (datasource) result.datasource = datasource;
  if (applicationProcessId) result.applicationProcessId = applicationProcessId;
  return result;
}

export function prepareDataDogPayload(...payloads) {
  const formatedPayloads = payloads.map(formatPayload);
  return deepMerge(...formatedPayloads) ?? {};
}

export function getPayload(optionalInfo, id) {
  const { datasource, domain, ...params } = optionalInfo;
  const datasourceObj = extractDataSource(datasource);
  const context = createContext(id, domain);
  return prepareDataDogPayload(context, params, datasourceObj);
}
